// extracted by mini-css-extract-plugin
export default {"link":"imageBanner_link__fqpM0","pagination":"imageBanner_pagination__FB21e","container":"imageBanner_container__GZlO5"};